import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import React from 'react';

const LazyFooterDynamicADP = lazy(
  () =>
    import('./FooterDynamic.eager').then(mod => ({
      default: mod.FooterDynamicADP,
    })),
  {fallback: <FooterSkeleton />},
);

export const FooterDynamicADP = () => (
  <LazyFooterDynamicADP hideCategories={false} />
);
